import { useAllowedCountryDictionary, useBookmakerDictionary, useBotDictionary, useCountryDictionary, useCustomLeagueDictionary, useLeagueGroupDictionary, useTimeZoneDictionary } from '@/stores';

export function setRemoteDictionaries(dictionaries: Record<string, any[]>) {
    for (const dictionaryName in dictionaries) {
        if (dictionaryName === 'AllowedCountry') {
            const store = useAllowedCountryDictionary();
            store.setData(dictionaries[dictionaryName]);
        }

        if (dictionaryName === 'Country') {
            const store = useCountryDictionary();
            store.setData(dictionaries[dictionaryName]);
        }

        if (dictionaryName === 'CustomLeague') {
            const store = useCustomLeagueDictionary();
            store.setData(dictionaries[dictionaryName]);
        }

        if (dictionaryName === 'Site') {
            const store = useBookmakerDictionary();
            store.setData(dictionaries[dictionaryName]);
        }

        if (dictionaryName === 'LeagueGroup') {
            const store = useLeagueGroupDictionary();
            store.setData(dictionaries[dictionaryName]);
        }

        if (dictionaryName === 'Bot') {
            const store = useBotDictionary();
            store.setData(dictionaries[dictionaryName]);
        }

        if (dictionaryName === 'TimeZone') {
            const store = useTimeZoneDictionary();
            store.setData(dictionaries[dictionaryName]);
        }
    }
}
